import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.container = this.element.querySelector('.container-cards');

    if (!this.container)
      return;

    this.element.style.width = `${this.element.offsetWidth}px`;
    this.updateContainer();
  }

  updateContainer() {
    let width = [...this.container.children].reduce((a, c) => {
      return a += c.offsetWidth
    }, 0);

    this.container.style.width = `${width}px`;
    this.container.classList.toggle('d-flex', true);
  }
}
